import { render, staticRenderFns } from "./SchoolIntroduction.vue?vue&type=template&id=21169f69&"
import script from "./SchoolIntroduction.vue?vue&type=script&lang=js&"
export * from "./SchoolIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./SchoolIntroduction.vue?vue&type=style&index=0&id=21169f69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports